import { ICard } from '../../card/types';
import { ICardsComparator } from './types';
import { compareNumbers } from './compareNumbers';

const getCardValue = (
    card: ICard
): number => card.dueDate;

export const dueDate: ICardsComparator = {
    getCardValue,
    sort: compareNumbers
}
